import React, { forwardRef, useImperativeHandle, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PolarAnswer } from "./PolarAnswer";
import "animate.css";
import TextSection from "../../SharedComponents/TextSection";

const PolarImage = forwardRef((props, ref) => {
  const [selectedAnswer, setSelectedAnswer] = useState(props.q.answer || null); // Store selected answer

  const [textAnimationClassName, setTextAnimationClassName] = useState(props.textEntryAnimation);
  const [answersAnimationClassName, setAnswersAnimationClassName] = useState(props.answersEntryAnimation);

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const ExitAnimation = async (goingTo, isNextDifferent, isPreviousDifferent) => {
    if (goingTo === "next") {
      if (isNextDifferent) {
        setTextAnimationClassName("animate__fadeOutUp");
        setAnswersAnimationClassName("animate__fadeOutDown");
      } else {
        setTextAnimationClassName("temp");
        setAnswersAnimationClassName("animate__fadeOutDown");
      }
    }

    if (goingTo === "previous") {
      if (isPreviousDifferent) {
        setTextAnimationClassName("animate__fadeOutUp");
        setAnswersAnimationClassName("animate__fadeOutDown");
      } else {
        setTextAnimationClassName("temp");
        setAnswersAnimationClassName("animate__fadeOutDown");
      }
    }

    await timeout(400);
  };

  useImperativeHandle(ref, () => ({
    ExitAnimation, // exposing this function
  }));

  let HandleAnswering = async (a, id) => {
    setSelectedAnswer(a); // Update selected answer state
    await props.SetAnswer(props.q.order, a, props.n + 1, "polar");
  };

  return (
    <>
      <TextSection
        text="Hangi taraftaki ifade sizi daha iyi tanımlıyorsa o taraftaki seçeneklerden birini seçiniz (1- Biraz tanımlıyor, 2- Oldukça tanımlıyor, 3- Tamamen tanımlıyor)"
        class={`question-text-segment text-container text-color-gray-light animate__animated animate__faster text-20 `}
        animation={textAnimationClassName}
      />
      <div className={`animate__animated   animate__faster ${answersAnimationClassName}`}>
        <Row style={{ margin: 0, padding: 0 }}>
          <Col className="polar-question-text-col" xs={{ span: 6, order: 1 }} lg={{ span: 4, order: 1 }}>
            {window.innerWidth <= 500 && <br />}
            <h4
              className="polar-question-text"
              style={{
                fontSize: window.innerWidth >= 500 ? "20px" : "14px",
                marginLeft: window.innerWidth >= 500 ? "40px" : "20px",
              }}
            >
              {props.q.leftPolar}
            </h4>
          </Col>
          <Col
            xs={{ span: 12, order: 3 }}
            lg={{ span: 4, order: 2 }}
            style={{
              padding: "0px",
              alignItems: "center",
              justifyContent: "center",
              display: "inline-flex",
              marginTop: window.innerWidth < 500 ? "40px" : "0px",
            }}
          >
            {[
              { label: 3, value: 1, tooltip: "Tamamen tanımlıyor", className: " big" },
              {
                label: 2,
                value: 2,
                tooltip: "Oldukça tanımlıyor",
                className: " mid",
              },
              { label: 1, value: 3, tooltip: "Biraz tanımlıyor", className: " small" },
            ].map(({ label, value, tooltip, className }, index) => (
              <React.Fragment key={value}>
                <PolarAnswer
                  key={index}
                  label={label}
                  value={value}
                  tooltipContent={tooltip}
                  active={selectedAnswer}
                  prevAnswer={props.q.answer}
                  HandleAnswering={HandleAnswering}
                  btnClassName={className}
                />
                {index < 2 && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                    <path
                      d="M6 1L1.89319 5.10681C1.39989 5.60011 1.39989 6.39989 1.89319 6.89319L6 11"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
              </React.Fragment>
            ))}
            <span
              style={{
                height: window.innerWidth < 500 ? "400%" : "100%",
                marginTop: window.innerWidth < 500 ? "-150px" : "0px",
                width: "4px",
                borderRadius: "2px",
                backgroundColor: "#E8E8E8",
              }}
            ></span>
            {[
              { label: 1, value: 4, tooltip: "Biraz tanımlıyor", className: " small" },
              {
                label: 2,
                value: 5,
                tooltip: "Oldukça tanımlıyor",
                className: " mid",
              },
              { label: 3, value: 6, tooltip: "Tamamen tanımlıyor", className: " big" },
            ].map(({ label, value, tooltip, className }, index) => (
              <React.Fragment key={value}>
                <PolarAnswer
                  key={index}
                  label={label}
                  value={value}
                  tooltipContent={tooltip}
                  active={selectedAnswer}
                  prevAnswer={props.q.answer}
                  HandleAnswering={HandleAnswering}
                  float="right"
                  btnClassName={className}
                />
                {index < 2 && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                    <path
                      d="M1 11L5.10681 6.89319C5.6001 6.39989 5.60011 5.60011 5.10681 5.10681L1 1"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
              </React.Fragment>
            ))}
          </Col>

          <Col className="polar-question-text-col" xs={{ span: 6, order: 2 }} lg={{ span: 4, order: 3 }}>
            {window.innerWidth <= 500 && <br />}
            <h4
              className="polar-question-text"
              style={{
                fontSize: window.innerWidth >= 500 ? "20px" : "14px",
                marginRight: window.innerWidth >= 500 ? "40px" : "20px",
              }}
            >
              {props.q.rightPolar}
            </h4>
          </Col>
        </Row>
      </div>
    </>
  );
});
export default PolarImage;
